const choices_data = [
    {
        "answer": "",
        "correct": true,
    },
    {
        "answer": "",
        "correct": false
    },
    {
        "answer": "",
        "correct": false
    },
    {
        "answer": "",
        "correct": false
    },
]

const config = {
    type: 'EVALUATION',
    component: "Sev03",
    portrait: "/img/container/S-EV-03.jpg",
    body: {
        question: "",
        time: '1',
        content:"",
        choices: choices_data
    },
}

export { config }